import React from 'react'

function GestorDeudoresScreen() {
  return (
    <div>GestorDeudoresScreen</div>
  )
}

export default GestorDeudoresScreen